import { cn_dot, cn_mul, cn_normal, cn_polar, cn_sub } from '../utils/cn_utilities';
import { cn_element_type } from './cn_element_type';
import { cn_material } from './cn_material';

export class cn_element_type_layer_material extends cn_element_type {

    /**
     * @param {any} json
     * @param {import('./cn_building').cn_building} building
     */
    static unserialize(json, building) {
        throw new Error('Method not implemented.');
    }

    constructor(parent) {
        super(parent);
        this.class_name = 'cn_element_type_layer_material';
        this.layers = [cn_material.material_by_code(parent, 'unknown', 0.3)];
        this.is_expert = false;
    }

    /**
     * Gets thickness from layers
     * @returns {number}
     */
    get thickness() {
        return this.layers.map(it => it.thickness).reduce((a, b) => a + b, 0);
    }

    /**
     * Computes and returns U value
     * @returns {number}
     */
    get_U() {
        let U = 0;
        this.layers.forEach(l => U += l.thickness / l.conductivity);
        if (U < 1 / 999) return 999;
        return 1 / U;
    }

    /**
     * Switch to expert or non-expert.
     * @param {boolean} v
     */
    set_expert(v) {
        // to be overriden by subclasses if needed
        this.is_expert = v;
    }

    draw_shape(camera, shape, origin, direction) {
        let html = "";

        var w = camera.world_to_screen_scale * this.thickness;
        var h = w * 10;
        html += `<pattern id="${this.ID + camera.ID}" x="0" y="0" width="${w}" height="${h}" patternUnits="userSpaceOnUse">`;
        html += this.draw_layers(w, h, true);
        //html += `<rect x="3" y="2" width="${w}" height="${h}" fill="red" />`;
        html += '</pattern>';

        let dx = direction;
        let dy = cn_mul(cn_normal(dx),1);
        // @ts-ignore
        function transform(pt) {
            var pt1 = cn_sub(pt, origin);
            return [camera.world_to_screen_scale * cn_dot(dx, pt1), camera.world_to_screen_scale * cn_dot(dy, pt1)];
        }
        
        var angle = cn_polar(dy)[1] * 180 / Math.PI;

        var ort = camera.world_to_screen(origin);
        let path = "";
        path += `<g transform="translate(${ort[0]},${ort[1]}) rotate(${-90-angle})  scale(-1,1)">`;
        
        path += `<path d="`;
        shape.forEach((s,i) => {
            var t = transform(s);
            if (i == 0) path += ' M';
            else if (i == 1) path += ' L';
            path += ` ${t[0]} ${t[1]}`
        });
        path += ` Z" fill="url(#${this.ID + camera.ID})" stroke="black" />`;
        path += '</g>';

        return html + path;
    }
    
    draw_layers(width, height, fit_box) {
        let html = "";
        html += `<svg x="0" y="0" width="${width}" height="${height}" style="overflow:hidden">`;
        var sz = [width, height];
        var p0 = [0, 0];
        var p1 = [width, height];
        var scale = (fit_box && this.thickness > 0) ? width / this.thickness : width;
        p0[0] = (fit_box) ? 0 : sz[0] * (0.5 - this.thickness * 0.5);
        for (let i = 0; i < this.layers.length; i++) {
            p1[0] = p0[0];
            const vertical_line = '<line x1=\'' + p0[0] + '\' y1=\'' + p0[1] + '\' x2=\'' + p1[0] + '\' y2=\'' + p1[1] + '\' style=\'stroke:black\' />';
            p1[0] += scale * this.layers[i].thickness;
            html += this.layers[i].draw_material(p0, p1[0] - p0[0], p1[1] - p0[1], scale);
            html += vertical_line;
            p0[0] = p1[0];
            if (i == this.layers.length - 1)
                html += '<line x1=\'' + p0[0] + '\' y1=\'' + p0[1] + '\' x2=\'' + p1[0] + '\' y2=\'' + p1[1] + '\' style=\'stroke:black\' />';
        }
        html += "</svg>";
        return html;
    }
}
